export enum ProfilInfobulleEnum {
    // Modules
    SERVICES = "Accès au menu des services",
    ANASUP = "Module des analyses supplémentaires",
    CONTROLEPERF = "Module des contrôles de performances",
    MIR = "Module MIR",
    DATAHUB = "Module DataHub",

    ADMIN = "Accès au menu d'administration",
    SUIVICLIENT = "Module de gestion des clients",
    USER = "Module de gestion des utilisateurs",
    ORGANISME = "Module de gestion des organismes",
    PROFIL = "Module de gestion des profils",
    PORTEFEUILLE = "Module de transfert de portefeuilles entre agents",
    ABONNEMENT = "Module de gestion des abonnements",

    ANIMAL = "Accès au menu d'exploitation",
    FICHEANIMAL = "Module concernant la fiche animal",
    FICHECLIENT = "Module concernant la fiche exploitation client",

    SUIVI = "Accès au menu des suivis",
    LISTSYNCH = "Module du suivi des synchronisations de l'application",
    SUIVIPLANSTOURNEE = "Module du plan de tournée des agents",
    POINTAGES = "Module du suivi de temps de travail - Equipe",
    POINTAGESAGENT = "Module du suivi de temps de travail - Agent",
    SUIVIIMPORTS = "Module de suivi des imports des fichiers en erreur",

    DOCUMENTS = "Accès au menu des documents",
    DOCBILAN = "Module de génération du bilan de synthèse",
    DOCELEVEURS = "Module de recherche et de téléchargement de documents",
    DOCVALOLAIT = "Module de génération de document Valolait",

    TABLESREFERENCE = "Accès au menu des tables de référence",
    SORTIESUL = "Module de gestion des causes de sorties UL",

    // Fonctionnalités
    EDITIONEVENEMENT = "Autorise la modification d'un événement",
    CONTROLEPERFMODIF = "Autorise la modification d'un contrôle de performances",
    OBSMODIF = "Module des observations par passage d'un animal",
    GESTIONSERV = "Autorise la gestion des services pour un client",
    SUIVIACTAGENT = "Autorise l'accès au suivi d'activité d'un agent",
    SUIVIACTCLIENT = "Autorise l'accès au suivi d'activité d'un client",
}
